import { z } from 'zod'

const booleanSearchParam = z
  .preprocess((value) => value === true || value === 'true', z.boolean())
  .catch(false)

export const planPointSearchSchema = z.object({
  search: z.string().max(200).optional().catch(undefined),
  status: z.enum(['all', 'active', 'inactive']).catch('all'),
  create: booleanSearchParam,
})

export type PlanPointSearch = z.infer<typeof planPointSearchSchema>
